import { FloorbitLogo, Input } from "@facade/components/ui";

import { AccountMenu } from "../AccountMenu";
import { NotificationBell } from "@facade/features/notifications";
import { AppBarProps } from "./AppBar.types";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { cn } from "@facade/lib/utils";
import { useTranslation } from "react-i18next";

export function DefaultStartArea() {
  return (
    <Link to="/" className="flex">
      <FloorbitLogo size="md" />
    </Link>
  );
}

export function DefaultCenterArea() {
  const { t } = useTranslation();

  return (
    <Input
      placeholder={t("appbar.searchText")}
      startAdornment={<Search className="size-4" />}
    />
  );
}

export function DefaultEndArea() {
  return (
    <>
      <NotificationBell />
      <AccountMenu />
    </>
  );
}

export function AppBar({ slots = {}, className }: AppBarProps) {
  return (
    <header
      className={cn(
        "grid h-14 w-full grid-cols-[auto_minmax(200px,25%)_auto] items-center gap-4 border-b px-3 shrink-0",
        className,
      )}
    >
      <div className="flex min-w-0 items-center">{slots.start}</div>

      <div className="min-w-0">{slots.center}</div>

      <div className="flex min-w-0 items-center justify-end gap-2">
        {slots.end}
      </div>
    </header>
  );
}
